const MutationObserver =
  window.MutationObserver ||
  window.WebKitMutationObserver ||
  window.MozMutationObserver;

let observer;

class EventMutationObserverClass {
  constructor(callback) {
    this.callbackMutation = callback;
    observer = new MutationObserver(this.callbackMutations.bind(this));
  }

  observe(container) {
    return observer.observe(container, {
      childList: true,
      attributes: true,
      characterData: false,
      attributeOldValue: true,
      characterDataOldValue: false,
      subtree: true,
    });
  }

  disconnect() {
    return observer.disconnect();
  }

  callbackMutations(event) {
    if (typeof event.length !== 'undefined') {
      for (let i = 0; i < event.length; i++) {
        this.callbackMutation(event[i]);
      }
    }
  }
}

export default EventMutationObserverClass;
